// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"728":"c67cf3c8","888":"90842d52"}[chunkId] + ".chunk.js";
};